module.exports = __webpack_public_path__ + "static/media/structure.0c9e95d1.svg";